import { QrDownloadFormat, QrFormatOption } from '../utils/qrDownload';

interface QrFormatPickerProps {
  title: string;
  options: QrFormatOption[];
  disabledFormats?: QrDownloadFormat[];
  onPick: (format: QrDownloadFormat) => void;
  onCancel: () => void;
}

export function QrFormatPicker({ title, options, disabledFormats = [], onPick, onCancel }: QrFormatPickerProps) {
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 p-4">
      <div
        data-testid="qr-format-picker"
        className="w-full max-w-xs bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg p-4"
      >
        <p className="font-semibold text-gray-900 dark:text-white mb-3">{title}</p>
        <div className="space-y-2">
          {options.map(({ format, label, description }) => {
            const isDisabled = disabledFormats.includes(format);
            return (
              <button
                key={format}
                type="button"
                disabled={isDisabled}
                onClick={() => onPick(format)}
                className={`w-full text-left p-3 rounded-lg border-2 border-gray-200 dark:border-gray-700 transition-colors ${
                  isDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:border-primary'
                }`}
              >
                <span className="block text-sm font-medium text-gray-900 dark:text-white">{label}</span>
                <span className="block text-xs text-gray-500 dark:text-gray-400">
                  {isDisabled ? 'Could not prepare this file' : description}
                </span>
              </button>
            );
          })}
        </div>
        <button
          type="button"
          onClick={onCancel}
          className="mt-3 w-full text-sm text-gray-500 dark:text-gray-400 hover:underline"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
